import { PACKAGE_MAX_AGE } from '@components/views/package/detail/components/package-search-bar/SearchBarInterface';

import { ListingSearchRoomItemProps } from './ListingSearchGuestInterface';
import ListingSearchGuestItem from './SearchGuestItem';
import { GuestScrollWrapper } from './SearchGuestStyle';

const ListingSearchRoomItem = ({
  childGuestCount,
  adultGuestCount,
  childrenList,
  handleChildNumberIncrement,
  handleChildNumberDecrement,
  handleAdultNumberIncrement,
  handleAdultNumberDecrement,
  changeChildAge,
  guestsWrapperRef,
}: ListingSearchRoomItemProps) => {
  return (
    <GuestScrollWrapper
      ref={guestsWrapperRef}
      isOverflow={Boolean(childGuestCount)}
    >
      <ListingSearchGuestItem
        title='Yetişkin'
        subTitle='12+ Yaş'
        handleDecrement={handleAdultNumberDecrement}
        handleIncrement={handleAdultNumberIncrement}
        count={adultGuestCount}
        min={1}
      />

      <ListingSearchGuestItem
        title='Çocuk'
        subTitle='0-12 Yaş'
        handleDecrement={handleChildNumberDecrement}
        handleIncrement={handleChildNumberIncrement}
        count={childGuestCount}
        isChildCounter={true}
        childrenList={childrenList}
        changeChildAge={changeChildAge}
        maxAge={PACKAGE_MAX_AGE}
      />
    </GuestScrollWrapper>
  );
};

export default ListingSearchRoomItem;
